'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Visible = require('../Visible');

var _Visible2 = _interopRequireDefault(_Visible);

var _style = require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClearFix = function (_React$Component) {
  _inherits(ClearFix, _React$Component);

  function ClearFix() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ClearFix);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClearFix.__proto__ || Object.getPrototypeOf(ClearFix)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        _Visible2.default,
        {
          xs: _this.props.xs,
          sm: _this.props.sm,
          md: _this.props.md,
          lg: _this.props.lg,
          xl: _this.props.xl
        },
        _react2.default.createElement(
          'div',
          { style: (0, _style.getAfterStyle)() },
          _react2.default.createElement(
            'span',
            { style: (0, _style.getAfterContentStyle)() },
            '\xA0'
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ClearFix;
}(_react2.default.Component);

ClearFix.propTypes = {
  /**
   * Show on extra small devices
   */
  xs: _propTypes2.default.bool,
  /**
   * Show on small devices
   */
  sm: _propTypes2.default.bool,
  /**
   * Show on medium devices
   */
  md: _propTypes2.default.bool,
  /**
   * Show on large devices
   */
  lg: _propTypes2.default.bool,
  /**
   * Show on xl devices
   */
  xl: _propTypes2.default.bool
};
ClearFix.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false
};
exports.default = ClearFix;


//////////////////
// WEBPACK FOOTER
// ./~/react-grid-system/build/utilities/ClearFix/index.js
// module id = 1494
// module chunks = 0